module.exports = __webpack_public_path__ + "img/6-5.807ee2c5.png";